import { render, staticRenderFns } from "./CreateDashboardWidget.vue?vue&type=template&id=42db5e83"
import script from "./CreateDashboardWidget.vue?vue&type=script&lang=js"
export * from "./CreateDashboardWidget.vue?vue&type=script&lang=js"
import style0 from "./CreateDashboardWidget.vue?vue&type=style&index=0&id=42db5e83&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports